import { render, staticRenderFns } from "./SchedarioPeritiAttivi.vue?vue&type=template&id=0094f67e"
import script from "./SchedarioPeritiAttivi.vue?vue&type=script&lang=js"
export * from "./SchedarioPeritiAttivi.vue?vue&type=script&lang=js"
import style0 from "./SchedarioPeritiAttivi.vue?vue&type=style&index=0&id=0094f67e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports